export const sameSchedule = (left, right) => left.time === right.time &&
  [...left.days].sort().join(',') === [...right.days].sort().join(',');

export const conflictingDays = (schedules, time, days, editingSchedule) => {
  const usedDays = new Set();
  let skippedOriginal = false;

  schedules.forEach((item) => {
    if (!skippedOriginal && editingSchedule && item.playlistId === editingSchedule.playlistId && sameSchedule(item, editingSchedule)) {
      skippedOriginal = true;
      return;
    }
    if (item.time === time) item.days.forEach((day) => usedDays.add(day));
  });

  return days.filter((day) => usedDays.has(day));
};

export const updatedPlaylistSchedule = (current, days, time, editingSchedule) => {
  const schedule = Array.isArray(current) ? [...current] : [];
  const next = { days: [...days], time };

  if (!editingSchedule) return [...schedule, next];

  const index = schedule.findIndex((item) => sameSchedule(item, editingSchedule));
  if (index < 0) return null;
  schedule[index] = { ...schedule[index], ...next };
  return schedule;
};

export const withoutSchedule = (current, itemToRemove) => {
  let removed = false;
  return current.filter((item) => {
    if (!removed && sameSchedule(item, itemToRemove)) {
      removed = true;
      return false;
    }
    return true;
  });
};
